import type { LC_GetPermissionLevelsOut, PermissionLevel } from './permissionLevels.types';


export const mapPermissionLevels = (out: LC_GetPermissionLevelsOut): PermissionLevel[] => {
  if (!out?.length) return [];
  return out.map((item) => ({
    level: item.level,
    description: item.description || '',
  }));
};
